import { apiErrorMessage, isApiError, ResponseParseError } from '@agos/api-client'
import { tt } from '@agos/shared'

/**
 * What the server answered, said on a failed read - FRONTEND.md §9.746, owner O118.
 *
 * Sereď's *Prehľad nápojov sa nepodarilo načítať* came with no reason: §9.743 named the server's answer for a
 * refusal (403) only, and the banner the owner quoted had no refusal line - so it was something else, and nothing
 * on the screen said what. Three different faults read the same there, and each has a different next step:
 *
 * - **the server answered with an error** - `HTTP 500` and its sentence, which is in *Logy*;
 * - **the server answered and the page could not read it** - a proxy's error page, say;
 * - **the request never arrived** - the connection, not the server.
 *
 * `HTTP` and the number are not Slovak and are not translated: they are what somebody reading a screenshot
 * types into a search.
 */
export function serverAnswer(error: unknown): string {
  if (isApiError(error)) {
    const sentence = apiErrorMessage(error, '')
    return sentence === '' ? `HTTP ${error.status}` : `HTTP ${error.status} - ${sentence}`
  }
  if (error instanceof ResponseParseError) {
    return `HTTP ${error.status} - ${tt('odpoveď servera sa nedala prečítať')}`
  }
  return tt('Server neodpovedal - požiadavka sa k nemu nedostala.')
}
